<script setup lang="ts">
const siteUrl = useSiteUrl()

// const articles = await useLatestArticles();
const articles = [
  {
    id: 1,
    title: 'تفاوت دلار سفید و آبی چیست؟<br/> انواع ارز را بشناسید',
    content: 'دلار آبی و سبز موقع خرید تفاوتی ندارند ولی زمان فروش دلار سبز ارزان تر است...',
    Img_Url: '/home/img/home/blog-image-1.png',
    url: siteUrl(
      '/blog/%d8%aa%d9%81%d8%a7%d9%88%d8%aa-%d8%af%d9%84%d8%a7%d8%b1-%d8%b3%d9%81%db%8c%d8%af-%d9%88-%d8%a2%d8%a8%db%8c-%da%86%db%8c%d8%b3%d8%aa/'
    ),
  },
  {
    id: 2,
    title: 'بانکداری نوین یا<br/> بانکداری سنتی؟!',
    content: 'جهان، روز به روز در حال پیشرفت است و همگان در پی یافتن راهی برای حل مشکلات...',
    Img_Url: '/home/img/home/blog-image-2.png',
    url: siteUrl(
      '/blog/%d8%a8%d8%a7%d9%86%da%a9%d8%af%d8%a7%d8%b1%db%8c-%d9%86%d9%88%db%8c%d9%86-%db%8c%d8%a7-%d8%a8%d8%a7%d9%86%da%a9%d8%af%d8%a7%d8%b1%db%8c-%d8%b3%d9%86%d8%aa%db%8c%d8%9f/'
    ),
  },
  {
    id: 3,
    title: 'پرداخت دانشگاه‌های خارج<br/> از کشور',
    content: 'این روزها اهداف بسیاری از دانشجویان داخل ایران، سفر به کشوری دیگر برای...',
    Img_Url: '/home/img/home/blog-image-3.png',
    url: siteUrl(
      '/blog/%d9%be%db%8c-%d8%ac%db%8c%d8%a8%d8%9b-%d8%b1%d9%88%d8%b4%db%8c-%d9%85%d9%86%d8%a7%d8%b3%d8%a8-%d8%a8%d8%b1%d8%a7%db%8c-%d9%be%d8%b1%d8%af%d8%a7%d8%ae%d8%aa-%d8%b4%d9%87%d8%b1%db%8c%d9%87-%d8%af%d8%a7/'
    ),
  },
]
</script>

<template>
  <section class="w-full  pt-8 pb-6 lg:py-[80px] lg:px-24 bg-white">
    <BaseContainer>
      <div class="w-full flex flex-col items-center">
        <!-- title -->
        <div class="w-full flex justify-between items-center mb-10 px-6 lg:px-0">
          <h2 class="text-[#0F1114] text-lg lg:text-[28px] font-bold">
            آخرین مطالب مجله پی‌جیب
          </h2>
          <nuxt-link :to="siteUrl('/blog/')"
            class="flex items-center gap-2 font-bold text-[14px] lg:text-lg cursor-pointer">
            <span class="text-[#2E2EE5]">ادامه در وبلاگ</span>
            <img src="/home/img/home/arrow-square-left.svg" alt="" aria-hidden="true">
          </nuxt-link>
        </div>

        <div
          class="flex gap-4 notShowScrollbar overflow-x-auto lg:overflow-x-hidden overflow-y-hidden lg:grid grid-cols-3 w-full">
          <nuxt-link v-for="(article, index) in articles" :key="`article-${index}`"
            class="shrink-0 w-[85%] sm:w-1/2 lg:w-full bg-white rounded-2xl p-4 pe-6 border-2 border-[#D5DDEA] flex flex-col items-start"
            :class="[
              index === 0 ? 'ms-6 lg:ms-0' : '',
              index === articles.length - 1 ? 'me-6 lg:me-0' : ''
            ]" :to="`${article.url}`" external target="_blank" rel="noopener noreferrer">
            <div class="flex w-full gap-3">
              <img class="w-[76px] h-[102px] rounded-lg me-3 bg-gray-400" :src="article.Img_Url"
                :alt="article.title.replace(/<br\/?>/g, ' ')">
              <div class="flex flex-col">
                <!-- eslint-disable-next-line vue/html-self-closing -->
                <h4 class="text-[#0F1114] font-semibold lg:text-lg mb-2" v-html="article.title"></h4>
                <p class="text-[#0F1114] text-[12px] lg:text-sm">
                  {{ article.content }}
                </p>
              </div>
            </div>
          </nuxt-link>
        </div>

      </div>
    </BaseContainer>
  </section>
</template>

<style>
/* .p-carousel-item-list:dir(rtl){
    flex-direction: row !important;
} */

.p-carousel-indicator .p-carousel-indicator-button {
  background: #c9cbf2 !important;
  background-color: #c9cbf2 !important;
  border: 1px solid red !;
  width: 8px !important;
  height: 8px !important;
}

.p-carousel-indicator-active .p-carousel-indicator-button {
  background-color: #2e2ee5 !important;
  width: 56px !important;
  height: 8px !important;
}
</style>